import React, {
  createContext,
  useContext,
  useState,
} from "react";
import { IStory, IStoryCreate } from "pages/People/people.types";
import { useAppSelector } from "../store";

const emptyStory: IStoryCreate = {
  uuid: "",
  name: "",
  date_of_birth_day: null,
  date_of_birth_month: null,
  date_of_birth_year: null,
  date_of_death_day: null,
  date_of_death_month: null,
  date_of_death_year: null,
  is_cryonized: false,
  is_alive: true,
  enable_tribute: false,
  enable_memories: false,
  show_in_feed: false,
  place_of_birth: "",
  status: 1
}

// const statusMap = {
//   "Родственник": 1,
//   "Друг": 2,
//   "Публичное лицо": 3
// } as const;

const toFormData: (s: IStory) => IStoryCreate = (s) => {
  return {
    uuid: s.uuid,
    date_of_death_day: s.date_of_death_day,
    date_of_death_month: s.date_of_death_month,
    date_of_death_year: s.date_of_death_year,
    date_of_birth_day: s.date_of_birth_day,
    date_of_birth_month: s.date_of_birth_month,
    date_of_birth_year: s.date_of_birth_year,
    image: s.image,
    name: s.name,
    status: 1,
    description: s.description,
    enable_memories: s.enable_memories,
    enable_tribute: s.enable_tribute,
    is_alive: s.is_alive,
    is_cryonized: s.is_cryonized,
    place_of_birth: s.place_of_birth,
    show_in_feed: s.show_in_feed,
  }
}

type StoryFormContextType = {
  formData: IStoryCreate;
  updateFormData: (v: Partial<IStoryCreate>) => void;
};

const StoryFormContext = createContext<StoryFormContextType | undefined>(
  undefined
);

export const StoryFormProvider = ({children, initialStory}: {
  children: React.ReactNode;
  initialStory?: IStory;
}) => {
  const [formData, setFormData] = useState<IStoryCreate>(initialStory ? toFormData(initialStory) : emptyStory);

  const updateFormData = (v: Partial<IStoryCreate>) => {
    setFormData((p) => ({...p, ...v}));
  }

  return (
    <StoryFormContext.Provider value={{
      formData,
      updateFormData
    }}>
      {children}
    </StoryFormContext.Provider>
  );
};

export const useStoryFormContext = () => {
  const context = useContext(StoryFormContext);
  if (!context) {
    throw new Error("useStoryFormContext must be used within a StoryProvider");
  }
  return context;
};
